export var MVKPolygonType = {
  NEWBUILDING: 'newbuilding',
  SECTION: 'section'
};